// Informant Example
// ***
// This shows how to render a radio list widget

import { Form, FormProvider, SuperSchema } from '@updater/ui-informant';

export const schema: SuperSchema = {
  type: 'object',
  properties: {
    favouriteIcecream: {
      title: 'Favourite icecream',
      type: 'string',
      default: 'coffee',
      oneOf: [
        {
          const: 'chocolate',
          title: 'Chocolate',
        },
        {
          const: 'vanilla',
          title: 'Vanilla',
        },
        {
          const: 'coffee',
          title: 'Coffee',
        },
      ],
      ui: {
        component: 'radiolist',
      },
    },
  },
};

export const MyForm = () => {
  const handleSubmit = (values: any) => {
    alert(`Submitted values: ${JSON.stringify(values, null, 2)}`);
  };

  return (
    <FormProvider schema={schema} onSubmit={handleSubmit}>
      <Form />
    </FormProvider>
  );
};
